import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BLOG_POSTS } from "../data/content";
import { FadeUp, Stagger, StaggerItem } from "./Motion";

const formatDate = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const BlogTeaser = ({ compact = false }) => {
  return (
    <section
      data-testid="blog-teaser"
      className={`${compact ? "py-16" : "py-24 md:py-32"} bg-cream`}
    >
      <div className="container mx-auto px-6 md:px-10 xl:px-16">
        <FadeUp className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="eyebrow text-forest">Field Notes</p>
            <h2 className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight text-forest max-w-2xl">
              Stories from the farm & the frontier of agritech.
            </h2>
          </div>
          <Link to="/blog" className="link-underline text-forest" data-testid="blog-teaser-view-all">
            View all journal <ArrowRight size={14} />
          </Link>
        </FadeUp>

        <Stagger className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {BLOG_POSTS.map((p) => (
            <StaggerItem key={p.slug}>
              <Link
                to={`/blog`}
                data-testid={`blog-card-${p.slug}`}
                className="group block"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                    loading="lazy"
                  />
                  <span className="absolute top-4 left-4 bg-cream text-forest text-[10px] uppercase tracking-widest font-semibold px-3 py-1">
                    {p.category}
                  </span>
                </div>
                <div className="mt-6">
                  <span className="eyebrow text-muted-ink">{formatDate(p.date)}</span>
                  <h3 className="mt-3 font-serif text-2xl md:text-3xl text-forest leading-tight group-hover:text-saffron transition-colors">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-muted-ink">{p.excerpt}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-forest text-sm font-semibold tracking-wide uppercase">
                    Read essay <ArrowRight size={14} />
                  </span>
                </div>
              </Link>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};

export default BlogTeaser;
